import React, { useState } from "react";

import useHover from "../../hooks/useHover";

const AddKeywords = ({
  selectedKeywords,
  inputRef,
  onEntered,
  removeKeyword,
}) => {
  const [newKeyword, setNewKeyword] = useState("");
  const hover = useHover();

  function onEnter(e) {
    if (e.key == "Enter") {
      onEntered(newKeyword);
      setNewKeyword("");
    }
  }

  return (
    <div
      className="divColumn"
      style={{ width: "100%", justifyContent: "center" }}
    >
      <div
        className="divRow"
        style={{
          height: "20px",
          width: "100%",
          justifyContent: "center",
          marginBottom: "2px",
          marginTop: "2px",
        }}
      >
        {selectedKeywords.map((c) => (
          <div
            onClick={() => removeKeyword(c)}
            key={c}
            style={{
              fontStyle: "italic",
              fontFamily: "Roboto-Regular",
              color: "#353535",
              marginLeft: "5px",
              backgroundColor: "#c3c3c3",
              border: "1px solid gray",
              padding: "2px",
              borderRadius: ".2rem/.2rem",
            }}
          >
            {c}
          </div>
        ))}
      </div>
      <div
        className="divRow"
        style={{ width: "100%", justifyContent: "center" }}
      >
        <input
          maxLength={20}
          onKeyDown={onEnter}
          ref={inputRef}
          value={newKeyword}
          onChange={(e) =>
            setNewKeyword(e.target.value.replace(/[^a-z]/gi, ""))
          }
          style={{ backgroundColor: "#e3e3e3", textAlign: "center" }}
          placeholder="New Keyword"
        />
        <button
          onClick={() => {
            onEntered(newKeyword);
            setNewKeyword("");
          }}
          {...hover.divProps}
          style={{
            fontFamily: "Roboto-Bold",
            backgroundColor: "#e3e3e3",
            color: hover.hover ? "brown" : "gray",
          }}
        >
          Add
        </button>
      </div>
    </div>
  );
};

export default AddKeywords;
